module.exports = __webpack_public_path__ + "static/img/bg6.3c7ae9e9.png";